export const INITIALIZE = 'INITIALIZE';
export const SET_LAST_STEP = 'SET_LAST_STEP';
export const SET_SELECTED_GRADE = 'SET_SELECTED_GRADE';
export const SET_SELECTED_SUBJECT = 'SET_SELECTED_SUBJECT';
export const SET_SKIP_PERSONALISED = 'SET_SKIP_PERSONALISED';
export const SET_CHILD_SCREEN_NAME = 'SET_CHILD_SCREEN_NAME';
export const SET_BACK_BUTTON_LOADING = 'SET_BACK_BUTTON_LOADING';
export const SET_QUESTION_RESPONSE_DATA = 'SET_QUESTION_RESPONSE_DATA'
export const SET_BACK_BUTTON_NOT_LOADING = 'SET_BACK_BUTTON_NOT_LOADING';
export const SET_SV_ONBOARDING_EVENT_PARAMS = 'SET_SV_ONBOARDING_EVENT_PARAMS';
export const RESET_SV_ONBOARDING_EVENT_PARAMS = 'RESET_SV_ONBOARDING_EVENT_PARAMS';
export const SET_ONBOARDING_QUESTIONS_OUTCOME_DATA = 'SET_ONBOARDING_QUESTIONS_OUTCOME_DATA';
export const SET_MENTOR_INFO = 'SET_MENTOR_INFO'